import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaLogRequest } from '../../requests/srv-log/lista-log.request';
import { ListaLogResponse } from '../../responses/srv-log/lista-log.response';
import { ObterLogResponse } from '../../responses/srv-log/obter-log.response';
import { LogDadosSensiveisResponse } from '../../responses/srv-log/log-dados-sensiveis.response';

@Injectable({
  providedIn: 'root',
})
export class VisualizadorLogService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public listarLogs(request: ListaLogRequest): Observable<ListaLogResponse> {
    const uri: string = 'VisualizadorLog/listarLogs';

    return this.httpClient
      .post<ListaLogResponse>(environment.urlApiSRVLog + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public get(idLog: number): Observable<ObterLogResponse> {
    const uri: string = `VisualizadorLog/idLog/${idLog}`;

    return this.httpClient
      .get<ObterLogResponse>(environment.urlApiSRVLog + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public revelarDadosSensiveis(idLog: number): Observable<LogDadosSensiveisResponse> {
    const uri: string = `VisualizadorLog/idLog/${idLog}`;

    return this.httpClient
      .put<LogDadosSensiveisResponse>(environment.urlApiSRVLog + uri, null, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
